import { lazy } from 'react';

// project imports
import AuthGuard from 'utils/route-guard/AuthGuard';
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

const NewSuministrosUser = Loadable(lazy(() => import('views/administrator/SuministrosView/NewSuministrosView')));

const ListSuministrosUser = Loadable(lazy(() => import('views/administrator/SuministrosView/ListSuministrosView')));

const SuministrosRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/user/new-suministro/:id_suministros',
            element: <NewSuministrosUser />
        },        
        {
            path: '/user/list-suministro-view',
            element: <ListSuministrosUser />
        },        
    ]
};

export default SuministrosRoutes;